import { render, staticRenderFns } from "./VIllustrationImage.vue?vue&type=template&id=5c4570de"
import script from "./VIllustrationImage.vue?vue&type=script&lang=js"
export * from "./VIllustrationImage.vue?vue&type=script&lang=js"
import style0 from "./VIllustrationImage.vue?vue&type=style&index=0&id=5c4570de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports